/* --- Helpers --- */
function normalizeEmailForID5(email) {
  if (!email || !email.includes("@")) return "";
  let cleaned = email.trim().toLowerCase();
  let [username, domain] = cleaned.split("@");
  username = username.replace(/\./g, "").split("+")[0];
  return `${username}@${domain}`;
}

async function sha256(message) {
  try {
    const normalized = normalizeEmailForID5(message);
    const msgUint8 = new TextEncoder().encode(normalized);
    const hashBuffer = await crypto.subtle.digest("SHA-256", msgUint8);
    return Array.from(new Uint8Array(hashBuffer))
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("");
  } catch (err) {
    return null;
  }
}

export const getConfig = async () => {
  const userEmail = window.drupalSettings?.user?.email;
  const hashedEmail = await sha256(userEmail);

  const pdKeys = {
    ...(userEmail && { 1: encodeURIComponent(hashedEmail) }),
    8: encodeURIComponent(window.location.href),
    9: encodeURIComponent(window.location.host),
    12: encodeURIComponent(window.navigator.userAgent),
  };

  const pdRaw = Object.keys(pdKeys)
    .map((k) => `${k}=${pdKeys[k]}`)
    .join("&");
  const pdString = btoa(pdRaw);

  return {
    publisher: "Wall Street Oasis",
    globalTimeout: 1500, // This controls how long the system waits to bail if no response from Prebid or Amazon;
    amazonEnabled: false,
    gam: {
      lazyLoadSettings: {
        fetchMarginPercent: 50, // Fetch slots within X% viewport.
        renderMarginPercent: 50, // Render slots within X% viewport.
        mobileScaling: 2.0,
      },
    },
    prebid: {
      timeout: 1200,
      enableSendAllBids: false,
      enableTIDs: true,
      priceBuckets: {
        buckets: [
          {
            precision: 2,
            max: 9.0,
            increment: 0.01,
          },
          {
            precision: 2,
            max: 31.5,
            increment: 0.05,
          },
          {
            precision: 2,
            max: 76.5,
            increment: 0.1,
          },
        ],
      },
      bidderSettings: {
        standard: {
          storageAllowed: true,
          userSync: {
            filterSettings: {
              iframe: {
                bidders: "*",
                filter: "include",
              },
            },
          },
        },
      },
      userSync: {
        userIds: [
          {
            name: "sharedId",
            storage: {
              type: "cookie",
              name: "_pubcid",
              expires: 365,
            },
          },
          {
            name: "unifiedId",
            params: {
              partner: "cin08sv",
            },
            storage: {
              type: "cookie",
              name: "_unifiedId",
              expires: 60,
            },
          },
          {
            name: "id5Id",
            params: {
              partner: 1076,
              pd: pdString,
              externalModuleUrl:
                "https://cdn.id5-sync.com/api/1.0/id5PrebidModule.js",
            },
            storage: {
              type: "html5",
              name: "id5id",
              expires: 90,
              refreshInSeconds: 8 * 3600,
            },
          },
        ],
        auctionDelay: 50,
      },
      consentManagement: {
        gdpr: {
          cmpApi: "iab",
          timeout: 2000,
        },
        gpp: {
          cmpApi: "iab",
          timeout: 500,
        },
      },
      allowActivities: {
        accessDevice: {
          default: true,
        },
      },
    },
    amazon: {
      pubID: "940db4ee-28cf-4307-9b65-76d8ba12e927",
      adServer: "googletag",
      bidTimeout: 1000,
      schain: {
        complete: 1,
        ver: "1.0",
        nodes: [
          {
            asi: "favish.com", // Populate with the canonical domain of the advertising system where the seller.JSON file is hosted.
            sid: "7", // The identifier associated with the seller or reseller account within your advertising system
            hp: 1, // 1 or 0, whether this node is involved in the payment flow
          },
        ],
      },
    },
  };
};

export const breakpoints: Breakpoints = {
  desktop: 1200,
  tablet: 992,
  mobile: 0,
};

export const windowWidth: number = window.innerWidth;
